import React from 'react';

import { flexRender } from '@tanstack/react-table';

import classes from 'components/common/Tables/TableV8/components/Row/Row.module.scss';

export const Row = ({ row, rowClassName }) => {
    return (
        <div
            data-testid={'table-row-container'}
            className={`${classes.tableRowContainer} ${row.original.className ?? ''}`}
        >
            <div data-testid={'table-row'} key={row.id} className={`${classes.tableRow} ${rowClassName || ''}`}>
                {row.getVisibleCells().map((cell) => (
                    <div
                        data-testid={'data-cell'}
                        key={cell.id}
                        style={{
                            width: cell.column.getSize() !== 0 ? cell.column.getSize() : 150,
                            flex: cell.column.columnDef.meta?.isFixedSize ? 'none' : `${cell.column.getSize()} 0 auto`,
                        }}
                        className={`${classes.dataCell} ${cell.column.className ?? ''} `}
                    >
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </div>
                ))}
            </div>
        </div>
    );
};
